import React from "react";

import { useSubscription } from "@/hooks/useSubscription";

import { cn } from "@/utils/cn";

import { TUsageKey } from "@/types/TSubscription";

interface IPlanUsageProps {
	on: TUsageKey;
	className?: string;
}

/**
 * "3 / 3" next to a create button, red once the limit is reached.
 * Nothing on an unlimited plan, nothing while the state is not in.
 */
export const PlanUsage: React.FC<IPlanUsageProps> = ({ on, className }) => {
	const { state } = useSubscription();
	const usage = state?.usage[on];

	if (!usage || usage.max === null) return null;

	const full = usage.used >= usage.max;

	return (
		<span
			className={cn([
				"font-mono text-xs tabular-nums",
				full ? "text-red-600" : "text-neutral-500",
				className,
			])}
			data-testid={`plan-usage-${on}`}
			aria-label={`${usage.used} / ${usage.max}`}
		>
			{usage.used} / {usage.max}
		</span>
	);
};
